const Skip = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.links = document.getElementById('skip-links');
  };

  const eventListener = () => {
    DOM.links.addEventListener('focusIn', function (e) {
      e.preventDefault();
      DOM.links.classList.remove('hidden');
    });

    DOM.links.addEventListener('focusOut', function (e) {
      e.preventDefault();
      DOM.links.classList.add('hidden');
    })
  };

  const init = () => {
    cacheDOM();
    eventListener();

  };

  return {
    init

  }

})();

export default Skip;
